import { PERMISSIONS } from "@/services/permission"

export default [
  {
    path: "/employee/list",
    name: "EmployeeOverview",
    component: () => import("@/views/employee/EmployeeOverview"),
    meta: {
      title: "nav.employee.overview",
      requiresPermissions: [
        PERMISSIONS.VIEW_USER_GENERAL,
        PERMISSIONS.VIEW_USER_COMPANY_GENERAL,
        PERMISSIONS.VIEW_USER_COMPANY_SOCIAL_INSURANCE,
        PERMISSIONS.VIEW_USER_COMPANY_SOCIAL_INSURANCE_NUMBER,
        PERMISSIONS.VIEW_USER_COMPANY_PAY,
        PERMISSIONS.VIEW_USER_COMPANY_TOTAL_HOLIDAY_DAYS,
        PERMISSIONS.VIEW_USER_SYSTEM,
        PERMISSIONS.VIEW_USER_FILE,
        PERMISSIONS.VIEW_USER_EXTENDED,
      ],
      requiresAuth: true,
    },
  },
  {
    path: "/employee/create",
    name: "EmployeeCreate",
    component: () => import("@/views/employee/EmployeeCreate"),
    meta: {
      title: "employee.create.title",
      requiresAllPermissions: [PERMISSIONS.EDIT_USER_GENERAL, PERMISSIONS.EDIT_USER_SYSTEM],
      requiresAuth: true,
    },
  },
  {
    path: "/employee/:employeeId",
    name: "EmployeeDetail",
    props: true,
    component: () => import("@/views/employee/EmployeeDetail"),
    meta: {
      title: "nav.employee.overview",
      requiresPermissions: [
        PERMISSIONS.VIEW_USER_GENERAL,
        PERMISSIONS.VIEW_USER_COMPANY_GENERAL,
        PERMISSIONS.VIEW_USER_COMPANY_SOCIAL_INSURANCE,
        PERMISSIONS.VIEW_USER_COMPANY_SOCIAL_INSURANCE_NUMBER,
        PERMISSIONS.VIEW_USER_COMPANY_PAY,
        PERMISSIONS.VIEW_USER_COMPANY_TOTAL_HOLIDAY_DAYS,
        PERMISSIONS.VIEW_USER_SYSTEM,
        PERMISSIONS.VIEW_USER_FILE,
        PERMISSIONS.VIEW_USER_EXTENDED,
      ],
      requiresAuth: true,
    },
  },
]
